<template>
    <div class="p-3">
        Biznis moduli ...
    </div>
</template>

<script>
export default {
    name: "Business",
    components: {},
    props: {},
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    computed: {},
    filters: {},
    watch: {}
}
</script>

<style scoped>

</style>
